export function dataIsArray(value) {
    return Array.isArray(value);
}
export function dataIsBoolean(value) {
    return typeof value === "boolean";
}
export function dataIsFunction(value) {
    return typeof value === "function";
}
export function dataIsObject(value) {
    return (typeof value === "object" && value !== null && !(value instanceof FormData));
}
export function dataIsString(value) {
    return typeof value === "string";
}
//# sourceMappingURL=is.js.map